import React, { useState, useEffect } from "react";
import './style.css';

// --- CONFIGURATION ---
const API_KEY = "AIzaSyDC7jo5I2p7SEwALNWICtbAc85LbD7xgO8";
const SPREADSHEET_ID_ACTIVITES = "135y3p3u2Q_EcCQoo516rzQMPj-pwdy61HSWNYxyB4rs";
const SPREADSHEET_ID_SOIREES = "1frJBX-jIu_IRAH0VDiLJHUEP-p3w1TcJYdQ74NZvRAs";

// Fonction pour transformer un tableau de valeurs en liste d'objets via les headers
const transformSheetValues = (values) => {
    if (!values || values.length < 2) return [];
    const headers = values[0].map(h => h.toLowerCase().trim());
    const data = values.slice(1);

    return data.map(row => {
        let obj = {};
        headers.forEach((header, index) => {
            obj[header] = row[index] || "";
        });
        return obj;
    });
};

function Calendrier() {
    // --- ÉTATS (DATA + UI) ---

    const [activites, setActivites] = useState({});
    const [isActivitesOpen, setIsActivitesOpen] = useState(false);
    const [loadingActivites, setLoadingActivites] = useState(true);

    const [soirees, setSoirees] = useState({});
    const [isSoireesOpen, setIsSoireesOpen] = useState(false);
    const [loadingSoirees, setLoadingSoirees] = useState(true);

    // --- NOUVELLE LOGIQUE DE RÉCUPÉRATION (SANS TRI) ---
    const fetchFullSpreadsheet = async (spreadsheetId) => {
        try {
            const metaResponse = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}?key=${API_KEY}`
            );
            const metaData = await metaResponse.json();

            // 1. On récupère le nom exact des onglets dans l'ordre du fichier Sheets
            const sheetTitles = metaData.sheets.map(s => s.properties.title);
            const rangesParam = sheetTitles.map(t => `ranges=${encodeURIComponent(t)}!A:Z`).join('&');

            const dataResponse = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values:batchGet?key=${API_KEY}&${rangesParam}`
            );
            const dataJson = await dataResponse.json();

            const groups = {};

            // 2. On prépare les groupes dans le bon ordre
            sheetTitles.forEach(title => {
                groups[title] = [];
            });

            // 3. On remplit les groupes avec les lignes, sans les trier
            if (dataJson.valueRanges) {
                dataJson.valueRanges.forEach((range, index) => {
                    const sheetName = sheetTitles[index];
                    if (range.values) {
                        const sheetObjects = transformSheetValues(range.values);
                        // On garde uniquement les lignes qui ont au moins une date
                        groups[sheetName] = sheetObjects.filter(row => row.date);
                    }
                });
            }

            return groups;

        } catch (error) {
            console.error("Erreur API Sheets:", error);
            return {};
        }
    };

    useEffect(() => {
        fetchFullSpreadsheet(SPREADSHEET_ID_ACTIVITES).then(data => {
            setActivites(data);
            setLoadingActivites(false);
            setIsActivitesOpen(true);
        });

        fetchFullSpreadsheet(SPREADSHEET_ID_SOIREES).then(data => {
            setSoirees(data);
            setLoadingSoirees(false);
            setIsSoireesOpen(true);
        });
    }, []);

    const toggleActivites = () => setIsActivitesOpen(!isActivitesOpen);
    const toggleSoirees = () => setIsSoireesOpen(!isSoireesOpen);

    const renderFamilies = (item) => {
        return Object.keys(item)
            .filter(key => key.startsWith('famille') && item[key])
            .map((key, index) => (
                <div className="families" key={index} style={{padding: '0 10px 10px 0', color: '#ddd'}}>
                    • {item[key]}
                </div>
            ));
    };

    return (
        <div id="calendrier">

            {/* CADRE D'INTRODUCTION (STYLE HOME) */}
            <div id="invitation-container">
                <div className="invitation-content"><h1>CALENDRIER</h1></div>
                <br/>
                <div className="invitation-content">
                    Chers parents,
                </div>
                <br/>
                <div className="invitation-content">
                    À partir de juin 2026, Phoenix proposera deux années d’activités évoluant progressivement vers
                    l’organisation de soirées/cours de rock puis de soirées rallyes.
                </div>
                <div className="invitation-content">
                    Vous trouverez ci-dessous les calendriers des dates prévues pour les activités, soirées/cours de rock et
                    soirées rallyes. Ils seront mis à jour au fil des saisons.
                </div>
                <br/>
                <div className="invitation-content">
                    Certaines dates sont encore disponibles pour les deux premières saisons. N’hésitez pas à nous
                    contacter par mail pour réserver une date, pour l’an prochain ou les années suivantes.
                </div>
                <br/>
                <div className="invitation-content">
                    Pour rappel, nous préconisons d’organiser les activités par groupe de 2 parents de garçons, les
                    soirées/cours de rock par groupe de 3 parents de garçons et les soirées par groupe de 2 ou 3 parents de
                    filles.
                </div>
                <br/>
                <div className="invitation-content">
                    Si des parents sont motivés pour organiser un week-end, n’hésitez pas à nous contacter. Et si
                    certains parents de garçons veulent organiser une soirée rallye, nous en serons ravies !
                </div>
                <div id="link-buttons">
                    <div className="link-button">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLScrebSYcjvfBBYr1riq6W5SAmRY1EnU_Oq8rGQweiqhay-5AQ/viewform?usp=dialog"
                           target="_blank">Inscription calendrier des activités</a>
                    </div>
                    <div className="link-button inactive">
                        <span>Inscription calendrier des soirées rallye</span>
                    </div>
                </div>
            </div>

            <br/><br/><br/>

            {/* ACTIVITÉS */}
            <section
                className={`membres-genre ${isActivitesOpen ? 'clicked' : ''}`}
                id="membres-garcons"
            >
                <div className="section-title" onClick={toggleActivites}>
                    <svg
                        className={isActivitesOpen ? 'rotation' : ''}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                    >
                        <path fill="#ffffff"
                              d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                    </svg>
                    <h2>Activités et cours de rock</h2>
                </div>

                <div className={`members-names ${!isActivitesOpen ? 'disappear' : ''}`}>
                    {Object.entries(activites).map(([year, items]) => (
                        <div key={year} style={{marginBottom: '20px'}}>
                            <div className="year"><h2>{year}</h2></div>
                            {items.map((item, idx) => (
                                <div key={idx} className="event-item">
                                    <div className="event-item-date" style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        fontWeight: 'bold',
                                        color: 'white',
                                        marginBottom: '5px'
                                    }}>
                                        {/*<p>Activité {item.activite || ''} le {item.date} organisée par:</p>*/}
                                        <p>
                                            {year === '2028-2029' || year === '2029-2030'
                                                ? `${item.activite || ''} ${item.date} organisée par :`.trim()
                                                : `Activité ${item.activite || ''} le ${item.date} organisée par :`
                                            }
                                        </p>
                                    </div>
                                    {renderFamilies(item)}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section>

            <br/><br/>

            {/* SOIRÉES */}
            <section
                className={`membres-genre ${isSoireesOpen ? 'clicked' : ''}`}
                id="membres-filles"
            >
                <div className="section-title" onClick={toggleSoirees}>
                    <svg
                        className={isSoireesOpen ? 'rotation' : ''}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                    >
                        <path fill="#ffffff"
                              d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                    </svg>
                    <h2>Soirées rallye</h2>
                </div>

                <div className={`members-names ${!isSoireesOpen ? 'disappear' : ''}`}>
                    {Object.entries(soirees).map(([year, items]) => (
                        <div key={year} style={{marginBottom: '20px'}}>
                            <div className="year"><h2>{year}</h2></div>
                            {items.map((item, idx) => (
                                <div key={idx} className="event-item">
                                    <div className="event-item-date"
                                         style={{fontWeight: 'bold', color: 'white', marginBottom: '5px'}}>
                                        <span>{item.date} organisée par:</span>
                                    </div>
                                    {renderFamilies(item)}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}

export default Calendrier;


/*import React, { useState, useEffect } from "react";
import './style.css';

// --- CONFIGURATION ---
const API_KEY = "AIzaSyDC7jo5I2p7SEwALNWICtbAc85LbD7xgO8";
const SPREADSHEET_ID_ACTIVITES = "135y3p3u2Q_EcCQoo516rzQMPj-pwdy61HSWNYxyB4rs";
const SPREADSHEET_ID_SOIREES = "1frJBX-jIu_IRAH0VDiLJHUEP-p3w1TcJYdQ74NZvRAs";

// Fonction pour transformer un tableau de valeurs en liste d'objets via les headers
const transformSheetValues = (values) => {
    if (!values || values.length < 2) return [];
    const headers = values[0].map(h => h.toLowerCase().trim());
    const data = values.slice(1);

    return data.map(row => {
        let obj = {};
        headers.forEach((header, index) => {
            obj[header] = row[index] || "";
        });
        return obj;
    });
};

// Fonction pour parser la date française et grouper
const parseFrenchDate = (dateStr) => {
    if (!dateStr) return { yearGroup: "Date Inconnue" };

    const months = {
        janvier: 0, février: 1, mars: 2, avril: 3, mai: 4, juin: 5,
        juillet: 6, août: 7, septembre: 8, octobre: 9, novembre: 10, décembre: 11
    };

    const cleanDate = dateStr.toLowerCase()
        .replace(/^(lundi|mardi|mercredi|jeudi|vendredi|samedi|dimanche)\s*!/, '')
        .trim();

    const parts = cleanDate.split(/[\s-/]+/);
    let dateObj = new Date();

    if (parts.length >= 3) {
        if (isNaN(parts[1])) {
            const day = parseInt(parts[0]);
            const month = months[parts[1]];
            const year = parseInt(parts[2]);
            dateObj = new Date(year, month, day);
        } else {
            dateObj = new Date(parts[2], parts[1] - 1, parts[0]);
        }
    }

    const y = dateObj.getFullYear();
    const m = dateObj.getMonth();
    const yearGroup = m >= 8 ? `${y} - ${y + 1}` : `${y - 1} - ${y}`;

    return { yearGroup, originalDate: dateStr };
};

function Calendrier() {
    // --- ÉTATS (DATA + UI) ---

    const [activites, setActivites] = useState({});
    const [isActivitesOpen, setIsActivitesOpen] = useState(false);
    const [loadingActivites, setLoadingActivites] = useState(true);

    const [soirees, setSoirees] = useState({});
    const [isSoireesOpen, setIsSoireesOpen] = useState(false);
    const [loadingSoirees, setLoadingSoirees] = useState(true);

    const fetchFullSpreadsheet = async (spreadsheetId) => {
        try {
            const metaResponse = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}?key=${API_KEY}`
            );
            const metaData = await metaResponse.json();

            const sheetTitles = metaData.sheets.map(s => s.properties.title);
            const rangesParam = sheetTitles.map(t => `ranges=${encodeURIComponent(t)}!A:Z`).join('&');

            const dataResponse = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values:batchGet?key=${API_KEY}&${rangesParam}`
            );
            const dataJson = await dataResponse.json();

            let allRows = [];
            if (dataJson.valueRanges) {
                dataJson.valueRanges.forEach(range => {
                    if (range.values) {
                        const sheetObjects = transformSheetValues(range.values);
                        allRows = [...allRows, ...sheetObjects];
                    }
                });
            }

            const groups = {};
            allRows.forEach(row => {
                if (!row.date) return;
                const { yearGroup } = parseFrenchDate(row.date);
                if (!groups[yearGroup]) groups[yearGroup] = [];
                groups[yearGroup].push(row);
            });

            return Object.keys(groups).sort().reduce((obj, key) => {
                obj[key] = groups[key];
                return obj;
            }, {});

        } catch (error) {
            console.error("Erreur API Sheets:", error);
            return {};
        }
    };

    useEffect(() => {
        fetchFullSpreadsheet(SPREADSHEET_ID_ACTIVITES).then(data => {
            setActivites(data);
            setLoadingActivites(false);
            setIsActivitesOpen(true);
        });

        fetchFullSpreadsheet(SPREADSHEET_ID_SOIREES).then(data => {
            setSoirees(data);
            setLoadingSoirees(false);
            setIsSoireesOpen(true);
        });
    }, []);

    const toggleActivites = () => setIsActivitesOpen(!isActivitesOpen);
    const toggleSoirees = () => setIsSoireesOpen(!isSoireesOpen);

    const renderFamilies = (item) => {
        return Object.keys(item)
            .filter(key => key.startsWith('famille') && item[key])
            .map((key, index) => (
                <div className="families" key={index} style={{padding: '0 10px 10px 0', color: '#ddd'}}>
                    • {item[key]}
                </div>
            ));
    };

    return (
        <div id="calendrier">

            {/!* CADRE D'INTRODUCTION (STYLE HOME) *!/}
            <div id="invitation-container">
                <div className="invitation-content"><h1>CALENDRIER</h1></div>
                <br/>
                <div className="invitation-content">
                    Chers parents,
                </div>
                <br/>
                <div className="invitation-content">
                    À partir de juin 2026, Phoenix proposera deux années d’activités évoluant progressivement vers
                    l’organisation de cours de rock puis de soirées rallyes.
                </div>
                <div className="invitation-content">
                    Vous trouverez ci-dessous les calendriers des dates prévues pour les activités, cours de rock et
                    soirées rallyes. Ils seront mis à jour au fil des saisons.
                </div>
                <br/>
                <div className="invitation-content">
                    Certaines dates sont encore disponibles pour les deux premières saisons. N’hésitez pas à nous
                    contacter par mail pour réserver une date, pour l’an prochain ou les années suivantes.
                </div>
                <br/>
                <div className="invitation-content">
                    Pour rappel, nous préconisons d’organiser les activités par groupe de 2 parents de garçons, les
                    cours de rock par groupe de 3 parents de garçons et les soirées par groupe de 2 ou 3 parents de
                    filles.
                </div>
                <br/>
                <div className="invitation-content">
                    Si des parents sont motivés pour organiser un week-end, n’hésitez pas à nous contacter. Et si
                    certains parents de garçons veulent organiser une soirée rallye, nous en serons ravies !
                </div>
                <div id="link-buttons">
                    <div className="link-button">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLScrebSYcjvfBBYr1riq6W5SAmRY1EnU_Oq8rGQweiqhay-5AQ/viewform?usp=dialog" target="_blank">Inscription calendrier des activités</a>
                    </div>
                    <div className="link-button inactive">
                        <span>Inscription calendrier des soirées rallye</span>
                    </div>
                </div>
            </div>

            <br/><br/><br/>

            {/!* ACTIVITÉS *!/}
            <section
                className={`membres-genre ${isActivitesOpen ? 'clicked' : ''}`}
                id="membres-garcons"
            >
                <div className="section-title" onClick={toggleActivites}>
                    <svg
                        className={isActivitesOpen ? 'rotation' : ''}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                    >
                        <path fill="#ffffff" d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                    </svg>
                    <h2>Activités et cours de rock</h2>
                </div>

                <div className={`members-names ${!isActivitesOpen ? 'disappear' : ''}`}>
                    {Object.entries(activites).map(([year, items]) => (
                        <div key={year} style={{marginBottom: '20px'}}>
                            <div className="year"><h2>{year}</h2></div>
                            {items.map((item, idx) => (
                                <div key={idx} className="event-item">
                                    <div className="event-item-date" style={{display:'flex', justifyContent:'space-between', fontWeight:'bold', color:'white', marginBottom:'5px'}}>
                                        <p>Activité {item.activite || ''} le {item.date} organisée par:</p>
                                    </div>
                                    {renderFamilies(item)}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section>

            <br/><br/>

            {/!* SOIRÉES *!/}
            <section
                className={`membres-genre ${isSoireesOpen ? 'clicked' : ''}`}
                id="membres-filles"
            >
                <div className="section-title" onClick={toggleSoirees}>
                    <svg
                        className={isSoireesOpen ? 'rotation' : ''}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                    >
                        <path fill="#ffffff" d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                    </svg>
                    <h2>Soirées rallye</h2>
                </div>

                <div className={`members-names ${!isSoireesOpen ? 'disappear' : ''}`}>
                    {Object.entries(soirees).map(([year, items]) => (
                        <div key={year} style={{marginBottom: '20px'}}>
                            <div className="year"><h2>{year}</h2></div>
                            {items.map((item, idx) => (
                                <div key={idx} className="event-item">
                                    <div className="event-item-date" style={{fontWeight:'bold', color:'white', marginBottom:'5px'}}>
                                        <span>{item.date} organisée par:</span>
                                    </div>
                                    {renderFamilies(item)}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}

export default Calendrier;*/







/*import React, { useState, useEffect } from "react";
import './style.css';

// --- CONFIGURATION ---
const API_KEY = "AIzaSyDC7jo5I2p7SEwALNWICtbAc85LbD7xgO8";
const SPREADSHEET_ID_ACTIVITES = "135y3p3u2Q_EcCQoo516rzQMPj-pwdy61HSWNYxyB4rs";
const SPREADSHEET_ID_SOIREES = "1frJBX-jIu_IRAH0VDiLJHUEP-p3w1TcJYdQ74NZvRAs";

// Fonction pour transformer un tableau de valeurs en liste d'objets via les headers
const transformSheetValues = (values) => {
    if (!values || values.length < 2) return [];
    const headers = values[0].map(h => h.toLowerCase().trim());
    const data = values.slice(1);

    return data.map(row => {
        let obj = {};
        headers.forEach((header, index) => {
            obj[header] = row[index] || "";
        });
        return obj;
    });
};

// Fonction pour parser la date française et grouper
const parseFrenchDate = (dateStr) => {
    if (!dateStr) return null;

    const months = {
        janvier: 0, février: 1, mars: 2, avril: 3, mai: 4, juin: 5,
        juillet: 6, août: 7, septembre: 8, octobre: 9, novembre: 10, décembre: 11
    };

    const cleanDate = dateStr.toLowerCase()
        .replace(/^(lundi|mardi|mercredi|jeudi|vendredi|samedi|dimanche)\s*!/, '')
        .trim();

    const parts = cleanDate.split(/[\s-/]+/);
    let dateObj = new Date(NaN);
    let isExact = false; // Indicateur par défaut

    if (parts.length >= 3) {
        // Date exacte (Jour Mois Année)
        if (isNaN(parts[1])) {
            dateObj = new Date(parseInt(parts[2]), months[parts[1]], parseInt(parts[0]));
        } else {
            dateObj = new Date(parts[2], parts[1] - 1, parts[0]);
        }
        isExact = true;
    }
    else if (parts.length === 2) {
        // Date approximative (Mois Année)
        const month = months[parts[0]];
        const year = parseInt(parts[1]);
        if (month !== undefined && !isNaN(year)) {
            dateObj = new Date(year, month, 1);
            isExact = false;
        }
    }

    const y = dateObj.getFullYear();
    if (isNaN(y)) return null;

    const m = dateObj.getMonth();
    const yearGroup = m >= 8 ? `${y} - ${y + 1}` : `${y - 1} - ${y}`;

    return { yearGroup, originalDate: dateStr, isExact }; // On renvoie isExact
};

function Calendrier() {
    // --- ÉTATS (DATA + UI) ---

    const [activites, setActivites] = useState({});
    const [isActivitesOpen, setIsActivitesOpen] = useState(false);
    const [loadingActivites, setLoadingActivites] = useState(true);

    const [soirees, setSoirees] = useState({});
    const [isSoireesOpen, setIsSoireesOpen] = useState(false);
    const [loadingSoirees, setLoadingSoirees] = useState(true);

    const fetchFullSpreadsheet = async (spreadsheetId) => {
        try {
            const metaResponse = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}?key=${API_KEY}`
            );
            const metaData = await metaResponse.json();

            const sheetTitles = metaData.sheets.map(s => s.properties.title);
            const rangesParam = sheetTitles.map(t => `ranges=${encodeURIComponent(t)}!A:Z`).join('&');

            const dataResponse = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values:batchGet?key=${API_KEY}&${rangesParam}`
            );
            const dataJson = await dataResponse.json();

            let allRows = [];
            if (dataJson.valueRanges) {
                dataJson.valueRanges.forEach(range => {
                    if (range.values) {
                        const sheetObjects = transformSheetValues(range.values);
                        allRows = [...allRows, ...sheetObjects];
                    }
                });
            }

            const groups = {};
            // Dans fetchFullSpreadsheet, modifiez la boucle :
            allRows.forEach(row => {
                if (!row.date) return;
                const parsed = parseFrenchDate(row.date);
                if (!parsed) return;

                // On rajoute l'info isExact à l'objet row pour l'utiliser plus tard
                row.isExact = parsed.isExact;

                const { yearGroup } = parsed;
                if (!groups[yearGroup]) groups[yearGroup] = [];
                groups[yearGroup].push(row);
            });

            return Object.keys(groups).sort().reduce((obj, key) => {
                obj[key] = groups[key];
                return obj;
            }, {});

        } catch (error) {
            console.error("Erreur API Sheets:", error);
            return {};
        }
    };

    useEffect(() => {
        fetchFullSpreadsheet(SPREADSHEET_ID_ACTIVITES).then(data => {
            setActivites(data);
            setLoadingActivites(false);
            setIsActivitesOpen(true);
        });

        fetchFullSpreadsheet(SPREADSHEET_ID_SOIREES).then(data => {
            setSoirees(data);
            setLoadingSoirees(false);
            setIsSoireesOpen(true);
        });
    }, []);

    const toggleActivites = () => setIsActivitesOpen(!isActivitesOpen);
    const toggleSoirees = () => setIsSoireesOpen(!isSoireesOpen);

    const renderFamilies = (item) => {
        return Object.keys(item)
            .filter(key => key.startsWith('famille') && item[key])
            .map((key, index) => (
                <div className="families" key={index} style={{padding: '0 10px 10px 0', color: '#ddd'}}>
                    • {item[key]}
                </div>
            ));
    };

    return (
        <div id="calendrier">

            {/!* CADRE D'INTRODUCTION (STYLE HOME) *!/}
            <div id="invitation-container">
                <div className="invitation-content"><h1>CALENDRIER</h1></div>
                <br/>
                <div className="invitation-content">
                    Chers parents,
                </div>
                <br/>
                <div className="invitation-content">
                    À partir de juin 2026, Phoenix proposera deux années d’activités évoluant progressivement vers
                    l’organisation de cours de rock puis de soirées rallyes.
                </div>
                <div className="invitation-content">
                    Vous trouverez ci-dessous les calendriers des dates prévues pour les activités, cours de rock et
                    soirées rallyes. Ils seront mis à jour au fil des saisons.
                </div>
                <br/>
                <div className="invitation-content">
                    Certaines dates sont encore disponibles pour les deux premières saisons. N’hésitez pas à nous
                    contacter par mail pour réserver une date, pour l’an prochain ou les années suivantes.
                </div>
                <br/>
                <div className="invitation-content">
                    Pour rappel, nous préconisons d’organiser les activités par groupe de 2 parents de garçons, les
                    cours de rock par groupe de 3 parents de garçons et les soirées par groupe de 2 ou 3 parents de
                    filles.
                </div>
                <br/>
                <div className="invitation-content">
                    Si des parents sont motivés pour organiser un week-end, n’hésitez pas à nous contacter. Et si
                    certains parents de garçons veulent organiser une soirée rallye, nous en serons ravies !
                </div>
                <div id="link-buttons">
                    <div className="link-button">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLScrebSYcjvfBBYr1riq6W5SAmRY1EnU_Oq8rGQweiqhay-5AQ/viewform?usp=dialog" target="_blank">Inscription calendrier des activités</a>
                    </div>
                    <div className="link-button inactive">
                        <span>Inscription calendrier des soirées rallye</span>
                    </div>
                </div>
            </div>

            <br/><br/><br/>

            {/!* ACTIVITÉS *!/}
            <section
                className={`membres-genre ${isActivitesOpen ? 'clicked' : ''}`}
                id="membres-garcons"
            >
                <div className="section-title" onClick={toggleActivites}>
                    <svg
                        className={isActivitesOpen ? 'rotation' : ''}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                    >
                        <path fill="#ffffff" d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                    </svg>
                    <h2>Activités et cours de rock</h2>
                </div>

                <div className={`members-names ${!isActivitesOpen ? 'disappear' : ''}`}>
                    {Object.entries(activites).map(([year, items]) => (
                        <div key={year} style={{marginBottom: '20px'}}>
                            <div className="year"><h2>{year}</h2></div>
                            {items.map((item, idx) => (
                                <div key={idx} className="event-item">
                                    <div className="event-item-date" style={{display:'flex', justifyContent:'space-between', fontWeight:'bold', color:'white', marginBottom:'5px'}}>
                                        <p>
                                            Activité {item.activite || ''}
                                            {item.isExact ? " le " : " en "}
                                            {item.date}
                                        </p>
                                    </div>
                                    {renderFamilies(item)}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section>

            <br/><br/>

            {/!* SOIRÉES *!/}
            <section
                className={`membres-genre ${isSoireesOpen ? 'clicked' : ''}`}
                id="membres-filles"
            >
                <div className="section-title" onClick={toggleSoirees}>
                    <svg
                        className={isSoireesOpen ? 'rotation' : ''}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                    >
                        <path fill="#ffffff" d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                    </svg>
                    <h2>Soirées rallye</h2>
                </div>

                <div className={`members-names ${!isSoireesOpen ? 'disappear' : ''}`}>
                    {Object.entries(soirees).map(([year, items]) => (
                        <div key={year} style={{marginBottom: '20px'}}>
                            <div className="year"><h2>{year}</h2></div>
                            {items.map((item, idx) => (
                                <div key={idx} className="event-item">
                                    <div className="event-item-date" style={{fontWeight:'bold', color:'white', marginBottom:'5px'}}>
                                        <span>{item.date}</span>
                                    </div>
                                    {renderFamilies(item)}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}

export default Calendrier;*/
